import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { useParams } from "react-router";
import { useGetDailyReportsQuery } from "../../../../../features/project/modules/dailyReports/dailyReportsApiSlice";
import { DailyReportsTable } from "../DailyReportsTable";

function CategoryAccordion({
  filters,
  title,
  icon,
  color,
  category,
  counter = 0,
  reports = [],
  isLoading,
  selectedReports,
  setSelectedReports,
}) {
  return (
    <Box
      display="flex"
      sx={{
        backgroundColor: "white",
        p: "8px",
        borderRadius: "0.5rem",
        columnGap: "0.5rem",
      }}
    >
      <Box>
        <Box
          sx={{
            width: "0.5rem",
            borderRadius: "0.25rem",
            backgroundColor: color,
            height: "100%",
          }}
        />
      </Box>
      <Box flex={1}>
        <Accordion
          sx={{ boxShadow: "none" }}
          slotProps={{ transition: { unmountOnExit: true } }}
        >
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Box display="flex" columnGap="0.5rem" alignItems="center">
              {icon}
              <Typography fontSize="0.875rem" fontWeight="500">
                {title} ({counter})
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <DailyReportsTable
              reports={reports}
              isLoading={isLoading}
              category={category}
              selectedReports={selectedReports}
              setSelectedReports={setSelectedReports}
            />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Box>
  );
}

export { CategoryAccordion };
